import React from 'react'

const VideoDescription = () => {
  return (
    <div>VideoDescription</div>
  )
}

export default VideoDescription